export const home = {
  pageHeader: {
    title: 'TOP',
  },
  welcome: '{{name}}様、こんにちは。',
}
